/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

const APP_CONFIG_FILE_NAME = "tri-app-config.json";
let triAppConfig = null;

export async function fetchTriAppConfig() {
  if (triAppConfig != null) {
    return triAppConfig;
  }
  if (process.env.NODE_ENV !== "production") {
    triAppConfig = {};
    triAppConfig.instanceId = process.env.REACT_APP_INSTANCE_ID;
    triAppConfig.tririgaUrl = process.env.REACT_APP_TRIRIGA_URL;
    triAppConfig.contextPath = process.env.REACT_APP_CONTEXT_PATH;
    triAppConfig.modelAndView = process.env.REACT_APP_MODEL_AND_VIEW;
    triAppConfig.appPath = process.env.REACT_APP_BASE_PATH;
    triAppConfig.appExposedName = process.env.REACT_APP_EXPOSED_NAME;
    triAppConfig.sso = process.env.REACT_APP_SSO === "true";
    return computeTririgaUrl(triAppConfig);
  }
  const getTriAppConfigResponse = await fetch(APP_CONFIG_FILE_NAME);
  if (!getTriAppConfigResponse.ok) {
    throw getTriAppConfigResponse.status;
  }
  triAppConfig = await getTriAppConfigResponse.json();
  return computeTririgaUrl(triAppConfig);
}

function computeTririgaUrl(triAppConfig) {
  if (triAppConfig.tririgaUrl == null || triAppConfig.tririgaUrl.length === 0) {
    triAppConfig.tririgaUrl = `${window.location.origin}${triAppConfig.contextPath}`;
  }
  return triAppConfig;
}

export function getTriAppConfig() {
  if (triAppConfig != null) {
    return triAppConfig;
  }
  throw new Error("TriAppConfig was not found");
}

export function setTriAppConfig(triAppConfigParameter) {
  triAppConfig = triAppConfigParameter;
}
